module.exports = __webpack_public_path__ + "img/Icon_Chat.ea5d933e.svg";